import * as React from 'react';
import * as main from "../../styles/main.module.scss";
import { StructureBlocks } from "../StructureBlocks";
import { accordionFaq } from "./accordionFaq";

export const Faq = () => {
  return (
    <section id="maintenance" style={{ padding: "40px 0" }}>
      <div className="container">
        <h2 className={main.title_h3}>Часто задаваемые вопросы</h2>
        <StructureBlocks data={accordionFaq} blockType={"faq"}/>
      </div>
    </section>
  );
};
